var DevOps = "DevOps";
var Gaming = "Gaming";
var Migration = "Migration";
var Other = "Other";
var useCase = {
	"Use case": "Use case",
	"AI & machine learning": "AI & machine learning",
	"Batch processing": "Batch processing",
	"Big data, analytics, & business intelligence": "Big data, analytics, & business intelligence",
	"Business applications - Microsoft": "Business applications - Microsoft",
	"Business applications - Oracle": "Business applications - Oracle",
	"Business applications - Other": "Business applications - Other",
	"Business applications - SAP": "Business applications - SAP",
	"Content delivery": "Content delivery",
	DevOps: DevOps,
	Gaming: Gaming,
	"Internet of things": "Internet of things",
	"Learning & certification": "Learning & certification",
	"Media services": "Media services",
	Migration: Migration,
	"Mobile applications": "Mobile applications",
	Other: Other,
	"Storage & backup": "Storage & backup",
	"Websites & web apps": "Websites & web apps"
};

export { DevOps, Gaming, Migration, Other, useCase as default };
